module.exports = __webpack_public_path__ + "static/media/flowers-1.0df2e438.png";